import React, { Children, PropsWithChildren } from 'react'

import { IProps } from './IProps'
import {
  GridMain,
  GridMainArea,
  GridMainHeading,
  GridOverview,
  MainAreaSection,
  OverviewCard,
} from './Main'
import { GridContainer } from './style'

export const Dashboard = (props: PropsWithChildren<IProps>) => {
  const { children } = props
  const childArray: any[] = Children.toArray(children)
  const header = childArray.find(
    child => child.type.name === DashBoardHeading.name,
  )
  const newsArray = childArray.filter(
    child => child.type.name === DashBoardNews.name,
  )
  const itemArray = childArray.filter(
    child => child.type.name === DashBoardItem.name,
  )
  const nonDashboardItemArray = childArray.filter(
    child => child.type.name === OutOfDashBoard.name,
  )

  if (!children) {
    throw new Error('At least  1 item is mandatory!')
  }

  return (
    <GridContainer backgroundColor={props.backgroundColor}>
      <GridMain key={'gridMain'} colorGuide={props.colorGuide}>
        {header ? (
          <GridMainHeading
            key={'gridMainHeading'}
            colorGuide={props.colorGuide}
            style={props.headingStyle}>
            {header}
          </GridMainHeading>
        ) : null}
        {/* VVV DashBoardItem with order -1 or less VVV*/}
        {itemArray ? (
          <GridMainArea
            key={'gridMainAreaAboveNews'}
            columnCount={props.itemColumnCount}>
            {itemArray.map((item, e) => {
              if (item.props.order < 0) {
                return (
                  <MainAreaSection
                    key={`${item.type}${e}`}
                    style={item.props.style}
                    colorGuide={props.colorGuide}>
                    {item}
                  </MainAreaSection>
                )
              }
            })}
          </GridMainArea>
        ) : null}
        {newsArray ? (
          <GridOverview key={'gridOverview'}>
            {newsArray.map((item, i) => {
              return (
                <OverviewCard key={`overviewCard${i}`}>{item}</OverviewCard>
              )
            })}
          </GridOverview>
        ) : null}
        {itemArray ? (
          <GridMainArea
            key={'gridMainAreaUnderNews'}
            columnCount={props.itemColumnCount}>
            {itemArray.map((item, e) => {
              if (
                item.props.order >= 0 ||
                typeof item.props.order === 'undefined'
              ) {
                return (
                  <MainAreaSection
                    key={`${item.type}${e}`}
                    style={item.props.style}
                    colorGuide={props.colorGuide}>
                    {item}
                  </MainAreaSection>
                )
              }
            })}
          </GridMainArea>
        ) : null}
        {nonDashboardItemArray ? nonDashboardItemArray.map(item => item) : null}
      </GridMain>
    </GridContainer>
  )
}

export const DashBoardHeading = (props: any) => props.children
export const DashBoardNews = (props: any) => props.children
export const DashBoardItem = (props: any) => props.children
export const OutOfDashBoard = (props: any) => props.children
